import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaFileExcel } from "react-icons/fa";
import NavBar from "../components/NavMenu";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const DetailPassingRate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const passedQuarters = location.state?.selectedQuarters || [
    "Q1 2025",
    "Q4 2024",
  ];
  const [selectedQuarters] = useState(passedQuarters);
  const [studentData, setStudentData] = useState([]);

  const parseQuarterYear = (quarterStr) => {
    const [qtr, year] = quarterStr.split(" ");
    return {
      qtr: parseInt(qtr.replace("Q", "")),
      year: parseInt(year),
    };
  };

  useEffect(() => {
    const fetchData = async () => {
      const { qtr, year } = parseQuarterYear(selectedQuarters[0]);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/getPassingRateByStudent?qtr=${qtr}&year=${year}`
        );
        const current = res.data.current || [];
        setStudentData(current);
      } catch (err) {
        console.error("Failed to fetch passing rate data", err);
      }
    };
    fetchData();
  }, [selectedQuarters]);

    const handlePrevious = () => {
    const passedQuarters = location.state?.selectedQuarters || [
      "Q1 2025",
      "Q4 2024",
    ];
    const extractedQuarter = parseInt(
      passedQuarters[0].split(" ")[0].replace("Q", "")
    );
    const extractedYear = parseInt(passedQuarters[0].split(" ")[1]);

    navigate("/home", {
      state: {
        view: "quality",
        selectedQuarter: extractedQuarter,
        selectedYear: extractedYear,
      },
    });
  };

  return (
    <>
      <NavBar />
      <div
        style={{
          backgroundColor: "#373636",
          margin: 20,
          borderRadius: 10,
          padding: 30,
          minHeight: "calc(100vh - 80px)",
          color: "#fff",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 20,
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <FaArrowLeft size={18} onClick={handlePrevious} />
            <h4 style={{ margin: 0 }}>Passing Rate Details</h4>
            <span
              style={{
                background: "#444",
                padding: "6px 12px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              {selectedQuarters[0]}
            </span>
            <span
              style={{
                background: "#444",
                padding: "6px 12px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              Total Count: {studentData.length}
            </span>
          </div>
          <button
            onClick={() => console.log("Export to Excel")}
            className="excel-button"
          >
            <FaFileExcel size={18} /> Export to Excel
          </button>
        </div>

        <div style={{ overflowX: "auto", borderRadius: 6 }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "#1f1f1f",
              borderRadius: 6,
              overflow: "hidden",
            }}
          >
            <thead style={{ backgroundColor: "#000" }}>
              <tr>
                <th style={thStyle}>NO</th>
                <th style={thStyle}>STUDENT ID</th>
                <th style={thStyle}>NAME</th>
                <th style={thStyle}>COURSE CODE</th>
                <th style={thStyle}>TOTAL SESSION</th>
                <th style={thStyle}>TOTAL PASSED</th>
                <th style={thStyle}>TOTAL FAILED</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(
                studentData.reduce((acc, item) => {
                  const level = item.course_level || "Unknown Level";
                  if (!acc[level]) acc[level] = [];
                  acc[level].push(item);
                  return acc;
                }, {})
              )
                .sort(([a], [b]) => a.localeCompare(b))
                .map(([level, students], levelIndex) => {
                  const totalSession = students.reduce(
                    (sum, s) => sum + s.totalSession,
                    0
                  );
                  const totalPassed = students.reduce(
                    (sum, s) => sum + s.totalPassed,
                    0
                  );
                  const totalFailed = students.reduce(
                    (sum, s) => sum + s.totalFailed,
                    0
                  );
                  return (
                    <React.Fragment key={levelIndex}>
                      <tr>
                        <td colSpan={7} style={groupHeaderStyle}>
                          {level}
                        </td>
                      </tr>
                      {students.map((row, idx) => (
                        <tr
                          key={idx}
                          style={{
                            borderTop: "1px solid #444",
                            backgroundColor:
                              row.totalFailed > 0
                                ? "#b03a2e"
                                : idx % 2 === 0
                                ? "#2b2b2b"
                                : "#252525",
                          }}
                        >
                          <td style={tdStyle}>{idx + 1}</td>
                          <td style={tdStyle}>{row.student_id}</td>
                          <td style={tdStyle}>{row.name}</td>
                          <td style={tdStyle}>{row.course_code}</td>
                          <td style={tdStyle}>{row.totalSession}</td>
                          <td style={tdStyle}>{row.totalPassed}</td>
                          <td style={tdStyle}>{row.totalFailed}</td>
                        </tr>
                      ))}
                      <tr
                        style={{
                          backgroundColor: "#1a1a1a",
                          borderTop: "1px solid #555",
                        }}
                      >
                        <td
                          colSpan={4}
                          style={{ ...tdStyle, textAlign: "right" }}
                        ></td>
                        <td style={{ ...tdStyle, color: "#ffa726" }}>
                          {totalSession}
                        </td>
                        <td style={{ ...tdStyle, color: "#ffa726" }}>
                          {totalPassed}
                        </td>
                        <td style={{ ...tdStyle, color: "#ffa726" }}>
                          {totalFailed}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const thStyle = {
  padding: "14px 12px",
  fontWeight: "bold",
  fontSize: 15,
  color: "#fff",
  borderBottom: "1px solid #444",
  textAlign: "center",
};
const tdStyle = {
  padding: "12px 12px",
  color: "#ddd",
  fontSize: 14,
  textAlign: "center",
};
const groupHeaderStyle = {
  backgroundColor: "#111",
  fontWeight: "bold",
  color: "#fff",
  padding: "10px 12px",
};

export default DetailPassingRate;
